// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.title {
    font-size: 23px;
    font-weight: 700;
  }
  
  .daily-item {
    background-color: #f5f5f5;
    border-radius: 15px;
    height: 40px;
    margin: 5px;
    align-items: center;
    cursor: pointer;
    display: flex;
    font-size: 14px;
    padding: 5px 20px;
  }
  
  .icon-small {
    width: 40px;
  }
  
  .daily-item .day {
    cursor: inherit;
    color: #212121;
    flex: 1 1;
    font-weight: 600;
    margin-left: 15px;
  }
  
  .description {
    cursor: inherit;
    flex: 1 1;
    margin-right: 15px;
    text-align: right;
  }
  
  .min-max {
    color: #757575;
  }
  
  .daily-details-grid {
    grid-row-gap: 0;
    grid-column-gap: 15px;
    column-gap: 15px;
    display: grid;
    flex: 1 1;
    grid-template-columns: auto auto;
    padding: 5px 15px;
    row-gap: 0;
  }
  
  .daily-details-grid-item {
    align-items: center;
    display: flex;
    height: 30px;
    justify-content: space-between;
  }
  
  .daily-details-grid-item label:first-child {
    color: #757575;
  }
  
  .daily-details-grid-item label:last-child {
    color: #212121;
  }`, "",{"version":3,"sources":["webpack://./src/components/forecast/forecast.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,cAAc;IACd,SAAS;IACT,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,SAAS;IACT,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,qBAAqB;IAErB,gBAAgB;IAChB,aAAa;IACb,SAAS;IACT,gCAAgC;IAChC,iBAAiB;IACjB,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,8BAA8B;EAChC;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB","sourcesContent":[".title {\n    font-size: 23px;\n    font-weight: 700;\n  }\n  \n  .daily-item {\n    background-color: #f5f5f5;\n    border-radius: 15px;\n    height: 40px;\n    margin: 5px;\n    align-items: center;\n    cursor: pointer;\n    display: flex;\n    font-size: 14px;\n    padding: 5px 20px;\n  }\n  \n  .icon-small {\n    width: 40px;\n  }\n  \n  .daily-item .day {\n    cursor: inherit;\n    color: #212121;\n    flex: 1 1;\n    font-weight: 600;\n    margin-left: 15px;\n  }\n  \n  .description {\n    cursor: inherit;\n    flex: 1 1;\n    margin-right: 15px;\n    text-align: right;\n  }\n  \n  .min-max {\n    color: #757575;\n  }\n  \n  .daily-details-grid {\n    grid-row-gap: 0;\n    grid-column-gap: 15px;\n    -webkit-column-gap: 15px;\n    column-gap: 15px;\n    display: grid;\n    flex: 1 1;\n    grid-template-columns: auto auto;\n    padding: 5px 15px;\n    row-gap: 0;\n  }\n  \n  .daily-details-grid-item {\n    align-items: center;\n    display: flex;\n    height: 30px;\n    justify-content: space-between;\n  }\n  \n  .daily-details-grid-item label:first-child {\n    color: #757575;\n  }\n  \n  .daily-details-grid-item label:last-child {\n    color: #212121;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
